var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-item",class:{ 'video': _vm.video }},[_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"alt":_vm.video ? _vm.media.name : _vm.media.title,"src":_vm.video ? _vm.media.thumbnail : _vm.media.image_url}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.video ? _vm.media.name : _vm.media.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }